export default __webpack_public_path__ + "static/media/activeTable.d002a093.svg";